<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchMmmmHistoryForm :propsMmmmNo="mmmmNo" :propsIsWaiting="isWaiting" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchMmmmHistoryForm from '@/components/organisms/terminal/form/SearchMmmmHistoryForm'

export default {
  name: 'SearchMmmmHistoryPage',

  components: { SearchMmmmHistoryForm },

  data() {
    return {
      mmmmNo: '',
      isWaiting: false,
    }
  },

  created() {
    const query = this.$route.query
    if (query.mmmmNo) {
      this.mmmmNo = query.mmmmNo
    }
    if (query.isWaiting) {
      this.isWaiting = this.$route.query.isWaiting.toString().toLowerCase() === 'true'
    }
  },
}
</script>
